"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oauthApi = exports.logoutAll = exports.logoutCurrent = exports.changeCurrentPassword = exports.checkUserPassword = exports.authWithSSO = exports.checkSSO = exports.revokeClient = exports.createClient = exports.fetchClient = exports.fetchClients = exports.fetchGroups = exports.getNewCode = exports.verifyCode = exports.createPasswordSet = exports.createPasswordCheck = exports.resetPasswordFinish = exports.resetPasswordStart = exports.changePassword = exports.resetPassword = exports.loginWithToken = exports.login = void 0;
const qs_1 = __importDefault(require("qs"));
const login = (caller) => ({ payload }) => caller('/api/oauth/login').post(payload);
exports.login = login;
const loginWithToken = (caller) => ({ payload }) => caller('/oauth/v2/token').post(payload);
exports.loginWithToken = loginWithToken;
const resetPassword = (caller) => ({ payload }) => caller('/api/oauth/reset_password/email').post(payload);
exports.resetPassword = resetPassword;
const changePassword = (caller) => ({ payload }) => caller('/api/oauth/reset_password/new_password').post(payload);
exports.changePassword = changePassword;
const resetPasswordStart = (caller) => ({ payload }) => caller('/api/oauth/reset_password/start').post(payload);
exports.resetPasswordStart = resetPasswordStart;
const resetPasswordFinish = (caller) => ({ payload }) => caller('/api/oauth/reset_password/finish').post(payload);
exports.resetPasswordFinish = resetPasswordFinish;
const createPasswordCheck = (caller) => ({ payload }) => caller('/api/oauth/create_password/check').post(payload);
exports.createPasswordCheck = createPasswordCheck;
const createPasswordSet = (caller) => ({ payload }) => caller('/api/oauth/create_password/set').post(payload);
exports.createPasswordSet = createPasswordSet;
const verifyCode = (caller) => ({ payload }) => caller('/api/oauth/login/mfa').post(payload);
exports.verifyCode = verifyCode;
const getNewCode = (caller) => ({ payload }) => caller('/api/oauth/login/mfa/code').post(payload);
exports.getNewCode = getNewCode;
const fetchGroups = (caller) => () => caller('/api/oauth/groups').get();
exports.fetchGroups = fetchGroups;
const fetchClients = (caller) => ({ accountId }) => caller(`/auth/v1/accounts/${accountId}/clients`).get();
exports.fetchClients = fetchClients;
const fetchClient = (caller) => ({ accountId, clientId }) => caller(`/auth/v1/accounts/${accountId}/clients/${clientId}`).get();
exports.fetchClient = fetchClient;
const createClient = (caller) => ({ accountId, payload }) => caller(`/auth/v1/accounts/${accountId}/clients`).post(payload);
exports.createClient = createClient;
const revokeClient = (caller) => ({ accountId, clientId }) => caller(`/api/oauth/accounts/${accountId}/clients/${clientId}/revoke`).post();
exports.revokeClient = revokeClient;
const checkSSO = (caller) => ({ payload }) => caller('/api/oauth/sso/check').get(payload);
exports.checkSSO = checkSSO;
const authWithSSO = (caller) => ({ payload }) => caller('/api/oauth/sso/auth').post(payload);
exports.authWithSSO = authWithSSO;
const checkUserPassword = (caller) => (paramsToUpdate) => caller('/api/oauth/change_password/start').post(paramsToUpdate);
exports.checkUserPassword = checkUserPassword;
const changeCurrentPassword = (caller) => (paramsToUpdate) => caller('/api/oauth/change_password/finish').post(paramsToUpdate);
exports.changeCurrentPassword = changeCurrentPassword;
const logoutCurrent = (caller) => () => caller('api/oauth/session/logout/current').post();
exports.logoutCurrent = logoutCurrent;
const logoutAll = (caller) => () => caller('api/oauth/session/logout/all').post();
exports.logoutAll = logoutAll;
const generateAuthCode = (caller) => ({ testId, accountId, clientId, grantedAccountId }) => {
    const queryString = qs_1.default.stringify({ client_id: clientId, test_id: testId, account_id: grantedAccountId }, { addQueryPrefix: true });
    return caller(`auth/v1/accounts/${accountId}/code${queryString}`).post();
};
const deleteCode = (caller) => ({ code, accountId }) => {
    return caller(`auth/v1/accounts/${accountId}/code/${code}`).delete();
};
const getTokenFromCode = (caller) => ({ code, clientId, clientSecret, refreshToken }) => {
    const postParams = {
        code,
        client_id: clientId,
        client_secret: clientSecret,
        refresh_token: refreshToken,
        grant_type: refreshToken ? 'refresh_token' : 'authorization_code',
    };
    return caller(`/auth/v1/token`).post(postParams);
};
const oauthApi = (caller) => ({
    login: (0, exports.login)(caller),
    loginWithToken: (0, exports.loginWithToken)(caller),
    resetPassword: (0, exports.resetPassword)(caller),
    changePassword: (0, exports.changePassword)(caller),
    resetPasswordStart: (0, exports.resetPasswordStart)(caller),
    resetPasswordFinish: (0, exports.resetPasswordFinish)(caller),
    createPasswordCheck: (0, exports.createPasswordCheck)(caller),
    createPasswordSet: (0, exports.createPasswordSet)(caller),
    verifyCode: (0, exports.verifyCode)(caller),
    getNewCode: (0, exports.getNewCode)(caller),
    fetchGroups: (0, exports.fetchGroups)(caller),
    fetchClients: (0, exports.fetchClients)(caller),
    fetchClient: (0, exports.fetchClient)(caller),
    createClient: (0, exports.createClient)(caller),
    revokeClient: (0, exports.revokeClient)(caller),
    checkSSO: (0, exports.checkSSO)(caller),
    authWithSSO: (0, exports.authWithSSO)(caller),
    checkUserPassword: (0, exports.checkUserPassword)(caller),
    changeCurrentPassword: (0, exports.changeCurrentPassword)(caller),
    logoutCurrent: (0, exports.logoutCurrent)(caller),
    logoutAll: (0, exports.logoutAll)(caller),
    generateAuthCode: generateAuthCode(caller),
    deleteCode: deleteCode(caller),
    getTokenFromCode: getTokenFromCode(caller),
});
exports.oauthApi = oauthApi;
//# sourceMappingURL=api.js.map